import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { LOGO } from "@/lib/site";
import { fadeUp, EASE_OUT_EXPO } from "@/lib/motion";

export default function FinalCta() {
  return (
    <section
      data-testid="final-cta"
      className="relative isolate overflow-hidden bg-[#050609] py-24 text-white md:py-36"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 60% at 50% 40%, rgba(79,13,255,0.55) 0%, rgba(10,181,255,0.18) 40%, transparent 70%)",
          filter: "blur(30px)",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/25 to-transparent"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent"
      />

      <div className="container-lw relative">
        <div className="mx-auto max-w-4xl text-center">
          <motion.img
            src={LOGO.wOnBlack}
            alt=""
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: EASE_OUT_EXPO }}
            className="mx-auto h-16 w-16 object-contain"
          />
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            className="mt-8 h-display text-5xl md:text-6xl lg:text-7xl"
          >
            Put the dealership inventory <br />
            <span className="text-gradient-lw">on a system.</span>
          </motion.h2>
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            custom={1}
            className="mx-auto mt-6 max-w-xl text-lg text-white/70"
          >
            LotWise Auto operates the dealership inventory presentation as
            an operation, not a task. Predictable cost, predictable output,
            one dealership standard.
          </motion.p>

          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            custom={2}
            className="mt-10 flex flex-wrap items-center justify-center gap-3"
          >
            <Link
              to="/request-a-visit"
              data-testid="final-cta-request-visit"
              className="btn-primary-lw text-base"
            >
              Get My Dealership Plan <ArrowUpRight className="h-4 w-4" />
            </Link>
            <a
              href="#dealer-qualifier"
              data-testid="final-cta-qualifier"
              className="btn-ghost-lw-dark text-base"
            >
              Calculate My Inventory Need
            </a>
          </motion.div>

          <div className="mt-14 grid grid-cols-2 gap-4 border-t border-white/10 pt-10 text-left sm:grid-cols-4">
            {[
              ["01", "Complete"],
              ["02", "Current"],
              ["03", "Consistent"],
              ["04", "Controlled"],
            ].map(([n, t], i) => (
              <motion.div
                key={n}
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                custom={i}
              >
                <div className="font-display text-xs tracking-widest text-white/40">
                  {n}
                </div>
                <div className="mt-2 font-display text-2xl font-bold">{t}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
